import { useQuery } from 'react-query';

import { getOrganizationList } from '../api/getOrganizationList';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

/**
 * Fetch organisation (hospital) master-data list.
 *
 * @param {Object} params - { search, page, limit, sort, isSearch }
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true]
 */
export const useOrganizationList = (params, { enabled = true } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.organizations(params),
    ({ signal }) => getOrganizationList(params, signal),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
      keepPreviousData: true,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useOrganizationList;
